import React from 'react';
import EspecialistaForm from './EspecialistaForm';

const EspecialistaEdit = () => {
  return <EspecialistaForm isEdit={true} />;
};

export default EspecialistaEdit;